import { getAction } from "@/request/menage.js";

// 主播二级域名落地弹窗配置（只读公开接口）
// 2026-10-14 主播弹窗配置化：数值与图片来自后端 anchor_popups 表，文字走 i18n 模板
//
// 注意：invite_id 直接拼进 URL 查询串，不走 getAction 的第二个参数。
// 实测把参数放在第二个参数时，服务端收到的是空的 invite_id，
// 接口会返回 {"code":"200","data":null}（表现为"短链落地不弹窗"且不报错）。
export default {
  popup: (params) => {
    const code = params && params.invite_id ? String(params.invite_id) : "";
    return getAction("/anchor/popup?invite_id=" + encodeURIComponent(code));
  },
};
